/* eslint no-console: "off",  */

import React from 'react';
import PropTypes from 'prop-types';

export default class LoginPage extends React.Component {
  static propTypes = {
    authClient: PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.authenticate();
  }

  authenticate() {
    this.props.authClient
      .startInteractiveAuth()
      .then(result => {
        console.log(result);
      })
      .catch(() => {
        console.log('Failed to authorize');
      });
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js